import {
  GET_WALLETS_START,
  GET_WALLETS_ERROR,
  GET_WALLETS_SUCCESS,
} from 'constants/action-types/wallets/getWallets';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_WALLETS_START:
      return {
        ...state,
        wallets: {
          ...state.wallets,
          loading: true,
          error: null,
        },
      };
    case GET_WALLETS_ERROR:
      return {
        ...state,
        wallets: {
          ...state.wallets,
          error: payload,
          loading: false,
        },
      };
    case GET_WALLETS_SUCCESS:
      return {
        ...state,
        wallets: {
          ...state.wallets,
          meta: payload.meta,
          loading: false,
          items: payload.data,
        },
      };
    default:
      return null;
  }
};
